import React from 'react';
import { FaTasks } from 'react-icons/fa';
import { Tooltip } from 'react-tooltip';

import { Box, Button, RFFReactSelect } from '@qwealth/qcore';
import { QTask, SelectOption } from '@qwealth/qdata';
import { commonSubscription } from '@qwealth/kyc';

import { StyledQNoteAuthorData } from './QNote.styled';
import { useAppSelector } from 'data/store';
import { selectHouseholdTasks } from 'data/selectors/activitiesSelectors';
import { RelatedTasksListToolTip } from 'components/common/Label/ToolTips';
import { BsInfoCircleFill } from 'react-icons/bs';
interface QNoteAuthorDataProps {
  createdDate: string | undefined;
  createdBy: string | undefined;
  updatedDate: string | undefined;
  updatedBy: string | undefined;
  task?: Partial<QTask> | null;
  setIsTaskModalOpen?: (isOpen: boolean) => void;
  noteId?: string;
  isQnoteModalFromTask?: boolean;
}

const QNoteAuthorData: React.FC<QNoteAuthorDataProps> = ({
  createdDate,
  createdBy,
  updatedBy,
  updatedDate,
  task,
  noteId,
  setIsTaskModalOpen,
  isQnoteModalFromTask,
}) => {
  const householdTasks = useAppSelector(selectHouseholdTasks);
  const taskOptions: SelectOption<number>[] = householdTasks
    .filter(task => task.status !== 'Completed')
    .map(task => ({ value: task.id!, label: `${task.title} - Due Date: ${task.dueDate ? task.dueDate : 'N/A'}` }));

  return (
    <StyledQNoteAuthorData>
      <Box>
        <Box fontWeight="bold" marginBottom="small">
          Created Date
        </Box>
        <Box> {createdDate}</Box>
      </Box>

      <Box>
        <Box fontWeight="bold" marginBottom="small">
          Created By
        </Box>
        <Box>{createdBy}</Box>
      </Box>
      <Box>
        <Box fontWeight="bold" marginBottom="small">
          Last Updated
        </Box>
        <Box>{updatedDate}</Box>
      </Box>
      <Box>
        <Box fontWeight="bold" marginBottom="small">
          Updated By
        </Box>
        <Box>{updatedBy}</Box>
      </Box>
      {task && (
        <Box className="task-row task-row-button ">
          <Box fontWeight="bold">Related Task</Box>
          <Button
            onClick={() => {
              if (setIsTaskModalOpen) setIsTaskModalOpen(true);
            }}
            variant="text"
            size="small"
            display="flex"
            flexDirection="row"
            alignItems="center"
            gap="small"
            disabled={isQnoteModalFromTask}
          >
            <FaTasks />
            {`${task.title} - Due Date: ${task.dueDate ? task.dueDate : 'N/A'}`}
          </Button>
        </Box>
      )}
      {!isQnoteModalFromTask && !noteId && (
        <Box className="task-row task-row-select">
          <Box display="flex" flexDirection="column" flex={1} gap="default">
            <RFFReactSelect
              label="Related Task (Optional)"
              name="taskId"
              subscription={commonSubscription}
              inputFieldProps={{
                options: taskOptions,
                placeholder: 'Select a task',
                isClearable: true,
              }}
            />
          </Box>
          <Tooltip id="related_tasks_list">{RelatedTasksListToolTip}</Tooltip>
          <Box data-tooltip-id="related_tasks_list" ml="small" flex={0}>
            <BsInfoCircleFill />
          </Box>
        </Box>
      )}
    </StyledQNoteAuthorData>
  );
};

export default QNoteAuthorData;
